'use client';

import { usePathname } from 'next/navigation';

// Constants
import { ROUTES, CV_TEMPLATE_ID } from '@shared/constants';

// Utils
import { combineClasses } from '@shared/utils';

// Components
import { type SidebarItemProps } from '@/components/SidebarDropdown';

// Old imports - kept for future multi-template support
// import { CV_TEMPLATES } from '@/components/template/resume';
// import SidebarDropdown from '@/components/SidebarDropdown';
// import CVTemplateMenu from '@/components/CVTemplateMenu';

const PreviewSidebarItem = ({
  icon,
  label,
  className
}: SidebarItemProps) => {
  const pathname = usePathname();

  // Old behavior: had a dropdown to let user choose a template before previewing
  // kept for future multi-template support
  // const handleSelectTemplate = (template: (typeof CV_TEMPLATES)[number]) => {
  //   const previewPath = `${pathname.replace(/\/[^/]+$/, '')}${ROUTES.PREVIEW}?templateId=${template.id}`;
  //   window.open(previewPath, '_blank', 'noopener,noreferrer');
  // };

  const handleSelectTemplate = () => {
    const previewPath = `${pathname.replace(/\/[^/]+$/, '')}${ROUTES.PREVIEW}?templateId=${CV_TEMPLATE_ID.AGILITYIO}`;
    window.open(previewPath, '_blank', 'noopener,noreferrer');
  };
  return (
    // Old behavior - kept for future multi-template support
    // <SidebarDropdown
    //   {...props}
    //   triggerAriaLabel="Open template selector to preview"
    //   iconVariant="fill"
    // >
    //   <CVTemplateMenu onSelect={handleSelectTemplate} />
    // </SidebarDropdown>

    // This will be removed once we support multi-template
    <div className={className} data-sentry-component="PreviewSidebarItem" data-sentry-source-file="PreviewSidebarItem.tsx">
      <button type="button" id={`sidebar-${label}-trigger`} aria-label="Preview resume" onClick={handleSelectTemplate} className={combineClasses('relative flex-center sm:flex-col gap-2', 'px-3 py-1 sm:h-25', 'sm:border-y-[5px] border-transparent', 'group outline-none cursor-pointer bg-transparent')}>
        <div className={combineClasses('size-4 sm:size-9 flex-center', 'sm:border-2 sm:border-tertiary sm:rounded-full', '[&_svg]:fill-white sm:group-hover:[&_svg]:fill-tertiary')}>
          {icon}
        </div>
        <span className={combineClasses('text-xs sm:text-4xs font-medium', 'uppercase sm:lowercase sm:truncate', 'text-white group-hover:text-tertiary')}>
          {label}
        </span>
      </button>
    </div>
  );
};
export default PreviewSidebarItem;